const supportedLocales = {
    en: {
        name: 'English'
    },
    ko: {
        name: '한국어'
    }
};

const localeList = Object.keys(supportedLocales);

const isRtl = () => false;

export {
    supportedLocales as default,
    isRtl,
    localeList
};
